namespace TabAurous {
    export interface TaxHistoryRequest extends Serenity.ListRequest {
        TaxId?: number;
        Date?: string;
    }
}
